import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'react-router-redux';
import store, {history} from './common/redux/store';
import App from './App';
import {unregister} from './registerServiceWorker';

render(
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<App/>
		</ConnectedRouter>
	</Provider>,
	document.getElementById('root')
);
unregister();
